<i [ngStyle]="{color: '#f35309'}" [class]="faSpinnerClass"></i>